import DOMPurify, { type Config } from 'dompurify';
// `Config` is a named TYPE export in dompurify 3.x — there is no `DOMPurify.Config` namespace.

/**
 * Mirror of the backend allow-list (`GanssRichTextSanitizer`): the FE never trusts stored HTML
 * either, so notes coming back from the API are re-sanitized before they reach the DOM.
 *
 * Tags/attrs match the editor's own output (TipTap: paragraphs, marks, lists, quote, headings,
 * links, images) — everything else is dropped, structure kept.
 */
const CONFIG: Config = {
  ALLOWED_TAGS: [
    'p', 'br', 'div', 'span', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'del', 'mark',
    'ul', 'ol', 'li', 'blockquote', 'h1', 'h2', 'h3', 'a', 'img', 'code', 'pre',
  ],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'target', 'rel'],
  ALLOWED_URI_REGEXP: /^(?:https?|mailto):/i,
  ALLOW_DATA_ATTR: false,
};

// DOMPurify keeps `data:` URIs on <img src> (img is in its built-in DATA_URI_TAGS set) regardless of
// ALLOWED_URI_REGEXP, and that set cannot be shrunk by config — so refuse them in a hook. Base64
// images are never accepted: an image is a URL the browser fetches, nothing inlined.
DOMPurify.addHook('uponSanitizeAttribute', (_node, data) => {
  if ((data.attrName === 'src' || data.attrName === 'href') && /^\s*data:/i.test(data.attrValue)) {
    data.keepAttr = false;
  }
});

/** Sanitize untrusted rich-text HTML (stored notes, pasted markup) down to the allow-list above. */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html ?? '', CONFIG);
}
